<c-footer class="c-footer">
<!-- <div>
    <a href="#" target="_blank">DataLive</a>
    <span> &copy; 2024</span>
</div>
<div class="ms-auto">
    Powered by
    <a href="#" target="_blank">
        <span> The Just Brand</span>
    </a>
</div> -->
</c-footer>